/**
 * @module timezone.actions
 */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { normalize } from 'normalizr';
import { graphqlRequest } from '~/adapters/graphqlRequest';
import * as schemas from '../schemas';
import * as transformers from '../transformers';
import { FetchTimezonesDocument, FetchTimezonesQueryResult } from '~/gql/graphql';

const fetchTimezones = createAsyncThunk<{ [id: number]: { id: number; name: string } }, { companyId: number }>(
  'company/fetchTimezones',
  async ({ companyId }, { rejectWithValue }) => {
    const res = await graphqlRequest<FetchTimezonesQueryResult>(FetchTimezonesDocument, { id: companyId });

    if (res.error) return rejectWithValue(res.error);

    const timezones = transformers.timezonesFrom(res.data?.getCompanyConfigDetails?.timezones);
    const normalizedData = normalize(timezones, [schemas.timezone]);

    return normalizedData;
  },
);

export const timezoneActions = {
  fetchTimezones,
};
